import axios from 'axios'

// config
import baseUrl from '../config'

export const fetchContributions = async params => {
  const response = await axios.get(`${baseUrl}/contributions`, { params, withCredentials: true })
  return response.data
}
